const styles = (theme) => ({
	container: {
		width: "100%",
		overflow: "hidden",
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-between",

		"@media(max-width: 1200px)": {
			minWidth: "550px",
			padding: "20px 20px 0px",
			alignItems: "center",
			justifyContent: "center",
			flexDirection: "column",
			display: "flex",
		},
		"@media(max-width: 600px)": {
			p: 0,

			minWidth: "344px",
		},
	},
	form: {
		background: theme.palette.background.wallpaper,
		height: "100vh",
		width: "50%",
		minWidth: "720px",
		"@media(max-width: 1200px)": {
			borderRadius: "20px",
			width: "80%",
			minWidth: "220px",
		},

		"@media(max-width: 600px)": {
			width: "100%",
			borderRadius: "0px",
		},
	},
	logo: {
		display: "flex",
		width: "70%",
		mt: 4,
		mb: 12,
		"@media(max-width: 1200px)": {
			mt: 0,
		},
		"@media(max-width: 600px)": {
			mt: 10,
		},
	},
	containerSubtitle: {
		display: "flex",
		flexDirection: "column",
		width: "70%",
		alignItems: "flex-start",
	},
	titleTypography: {
		fontWeight: 900,
		color: theme.palette.primary.main,
		fontSize: "16px",
		mb: "8px",
	},
	body: {
		alignItems: "center",
		justifyContent: "center",
		flexDirection: "column",

		display: "flex",
		minWidth: "820px",

		"@media(max-width: 1200px)": {
			width: "80vw",
			p: 0,
			pt: 10,

			alignItems: "center",
			minWidth: "500px",
		},
		"@media(max-width: 600px)": {
			width: "100%",
			minWidth: "100%",
			padding: "0px",
		},
	},
	content: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		gap: "25px",
		zIndex: 1,
		mt: 4,
		width: "100%",
		mr: 11,
		"@media(max-width: 1200px)": {
			mr: 5,
		},
		"@media(max-width: 600px)": {
			mr: 0,
			ml: 0,
			overflow: "hidden",
		},
	},
	boxLogo: {
		display: "flex",
		alignItems: "flex-end",
		ml: "5%",
		gap: 1,
	},
	boxImg: {
		backgroundRepeat: "no-repeat",
		display: "flex",
		width: "100%",
		height: "100vh",
	},
	textfield: {
		width: "70%",
		minWidth: "220px",

		opacity: "0.8",
		borderRadius: "4px",
	},
	button: {
		width: "100%",
		minWidth: "150px",
		maxWidth: "70%",
		// bgcolor: theme.palette.tertiary.main,
		// ":hover": {
		// 	bgcolor: theme.palette.tertiary.dark,
		// },
		// color: theme.palette.white.main,
		mt: "15px",
		borderRadius: "10px",
	},
	boxRecover: {
		display: "flex",
		width: "70%",
		justifyContent: "flex-end",
	},
	img: {
		width: "auto",
		maxHeight: "60px",
		maxWidth: "50%",
		minWidth: "200px",
	},
	imgText: {
		position: "absolute",
		bottom: 110,
		zIndex: 1,
		right: 110,
		"@media(max-width: 1200px)": {
			display: "none",
		},
	},
	boxForm: { display: "flex", flexDirection: "column", gap: 1, width: "700px" },
	buttonRecover: {
		display: "flex",
		color: theme.palette.text.main,
	},
	buttonNavigate: {
		width: "21%",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		mt: 0,
	},
});

export default styles;
